var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect2, _rect3, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTpIconLiquidityRich = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F2F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 37.332V39.2676L14.0479 40.9326H17.9336V39.3506L13.9834 37.332H10.5996Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86633 37.332V39.2676L10.3146 40.9326H14.2003V39.3506L10.2501 37.332H6.86633Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13281 37.332V39.2676L6.58105 40.9326H10.4668V39.3506L6.5166 37.332H3.13281Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73303 35.4648V37.4004L12.1813 39.0654H16.067V37.4834L12.1168 35.4648H8.73303Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53296 35.4648V37.4004L8.9812 39.0654H12.8669V37.4834L8.91675 35.4648H5.53296Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06641 35.4648V37.4004L5.51465 39.0654H9.40039V37.4834L5.4502 35.4648H2.06641Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0664 33.8672V35.8027L13.5146 37.4678H17.4004V35.8857L13.4502 33.8672H10.0664Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99976 33.0664V35.002L8.448 36.667H12.3337V35.085L8.38354 33.0664H4.99976Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86633 33.8672V35.8027L6.31458 37.4678H10.2003V35.8857L6.25012 33.8672H2.86633Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5996 36.332V38.2676L45.0479 39.9326H48.9336V38.3506L44.9834 36.332H41.5996Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8663 36.332V38.2676L41.3146 39.9326H45.2003V38.3506L41.2501 36.332H37.8663Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1328 36.332V38.2676L37.5811 39.9326H41.4668V38.3506L37.5166 36.332H34.1328Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.733 34.4648V36.4004L43.1813 38.0654H47.067V36.4834L43.1168 34.4648H39.733Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.533 34.4648V36.4004L39.9812 38.0654H43.8669V36.4834L39.9167 34.4648H36.533Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0664 34.4648V36.4004L36.5146 38.0654H40.4004V36.4834L36.4502 34.4648H33.0664Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0664 32.8672V34.8027L44.5146 36.4678H48.4004V34.8857L44.4502 32.8672H41.0664Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9998 32.0664V34.002L39.448 35.667H43.3337V34.085L39.3835 32.0664H35.9998Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8663 32.8672V34.8027L37.3146 36.4678H41.2003V34.8857L37.2501 32.8672H33.8663Z",
    fill: "#DEDEF7",
    stroke: "#CFCFF1",
    strokeWidth: 0.133333
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9177 16.4513L22.5786 15.5586H11.0655L10.0804 16.6206V24.9322H23.9177V16.4513Z",
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.246269
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8715 18.8359L10.0804 18.8359",
    stroke: "#118F72",
    strokeWidth: 0.246269
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4328 16.4513L39.0937 15.5586H26.5956V24.9322H40.4328V16.4513Z",
    fill: "#00AA7B",
    stroke: "#118F72",
    strokeWidth: 0.246269
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0002,
    y: 18,
    width: 1.3636,
    height: 3.63627,
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.227267
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6365,
    y: 18,
    width: 1.3636,
    height: 3.63627,
    fill: "#00D2A3",
    stroke: "#118F72",
    strokeWidth: 0.227267
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0107 41.0008L20.9322 30.0986C20.9957 29.9221 21.0336 29.7375 21.0449 29.5503L21.3163 25.0478H23.9787C23.9787 22.6853 23.9699 17.0612 23.9699 16.3739C23.6251 16.1276 23.1325 15.8814 22.64 15.4427H17.645L17.1461 16.3295C16.9219 16.7282 16.8433 17.1924 16.9239 17.6426L17.2042 19.2085C17.2154 19.2713 17.1955 19.3356 17.1508 19.3811C17.0738 19.4593 16.9475 19.4593 16.8705 19.3811L16.1649 18.6643L15.9621 20.7246C15.9565 20.7812 15.9317 20.8342 15.8918 20.8747C15.7458 21.023 15.4931 20.9372 15.4677 20.7306L15.3192 19.5234L14.745 21.0787C14.7089 21.1766 14.6156 21.2416 14.5112 21.2416C14.3736 21.2416 14.262 21.1301 14.262 20.9924V19.5234L13.9237 20.3826C13.8727 20.5122 13.7476 20.5973 13.6084 20.5973C13.3978 20.5973 13.2382 20.4074 13.2779 20.2006C13.6872 18.0668 14.6838 14.1551 15.9535 12.8654C17.2077 11.5914 21.1017 13.417 23.292 14.717C23.6118 14.9068 23.9739 15.0131 24.3458 15.0131H25.3044C25.5522 15.0131 25.7968 14.9663 26.028 14.8771C27.4096 14.3436 29.8801 13.4524 30.9653 13.2949C32.4454 13.0801 33.5026 13.7245 34.1369 14.154C34.6443 14.4976 34.7712 15.1563 34.7712 15.4427H30.4166C30.0861 15.4427 29.7641 15.5472 29.4966 15.7412C28.8793 16.1892 28.6743 17.0166 29.0111 17.701L34.6451 29.1468C34.7287 29.3167 34.7874 29.4977 34.8193 29.6844L36.4191 39.0284C36.4443 39.1752 36.5715 39.2826 36.7205 39.2826C36.8235 39.2826 36.9195 39.3344 36.9761 39.4205L36.9964 39.4516C37.144 39.6765 37.0134 39.979 36.7485 40.0258L32.4454 40.786L30.3719 30.676C30.3447 30.5436 30.304 30.4143 30.2504 30.2902L26.7995 22.3058C26.6471 21.953 26.2407 21.7867 25.8846 21.9314C25.6304 22.0347 25.459 22.2757 25.4448 22.5497L25.0598 29.9798C25.0501 30.167 25.0137 30.3519 24.9518 30.5288L21.8424 39.412C21.7321 39.7272 21.8106 40.0777 22.0449 40.3156L22.209 40.4823C22.2651 40.5393 22.2965 40.616 22.2965 40.696C22.2965 40.8643 22.1601 41.0008 21.9918 41.0008H17.0107Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.246269,
    strokeLinecap: "square"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0022 10.1094H27.0514C27.4206 10.1094 27.7198 10.4086 27.7198 10.7778C27.7198 11.147 27.4206 11.4463 27.0514 11.4463H27.0022C26.633 11.4463 26.3337 11.147 26.3337 10.7778C26.3337 10.4086 26.633 10.1094 27.0022 10.1094Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.246269,
    strokeLinecap: "square"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9761 12.3405C22.8554 11.3887 22.8556 10.5542 22.9791 9.57804C23.0963 8.65235 23.9207 8 24.8538 8H25.0327C26.0452 8 26.9028 8.76714 26.9715 9.77724C27.0321 10.6679 27.0468 11.4304 26.9993 12.226C26.9412 13.1987 26.0959 13.9104 25.1215 13.9104H24.8464C23.9167 13.9104 23.093 13.2629 22.9761 12.3405Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.246269,
    strokeLinecap: "square"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5694 9.96875H22.6186C22.9878 9.96875 23.2871 10.268 23.2871 10.6372C23.2871 11.0064 22.9878 11.3056 22.6186 11.3056H22.5694C22.2003 11.3056 21.901 11.0064 21.901 10.6372C21.901 10.268 22.2003 9.96875 22.5694 9.96875Z",
    fill: "#1C77EB",
    stroke: "#2D5AD9",
    strokeWidth: 0.246269,
    strokeLinecap: "square"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTpIconLiquidityRich);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tp_icon_liquidity_rich.080610194e9ff670b35aab377f0507b8.svg";